import React, {useContext, useEffect, useState} from 'react';
import $api from "../http";
import {useFetching} from "../hooks/useFetching";
import {Context} from "../index";
import BillsList from "../components/BillsList";



function Bills () {
    const {store} = useContext(Context);
    const [bills, setBills] = useState(store.bills);
    const [fetchBills, isPostsLoading, postError] = useFetching(async (limit, page) => {
        const response = await $api.get('/bills')
        if(response.status == 200) {
            setBills(response.data.bills);
            store.setBills(response.data.bills);
        } else {
            store.logout()
        }
    })

    useEffect(() => {
        fetchBills();
        const interval = setInterval(fetchBills, 300000);
        return () => clearInterval(interval);
    }, [])




    return (
        <div className="App">
            <BillsList billsList = {bills} />
        </div>
    );
}

export default Bills;
